// 羽毛球 【苏迪曼杯】
export default {
  data() {
    return {
      bigSportsList: [
        {
          id: 'BDM',
          CN: '羽毛球',
          EN: 'Badminton',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_11',
                localData: 'mode_27',
              },
            ],
          },
        },
      ],
    }
  },
}
